import { useRecoilValue } from 'recoil'
import userAtom from '@/pages/User/user.atom.ts'
import usePopup from '@/shared/hooks/usePopup.ts'
import { memo, useRef } from 'react'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import DropdownListItemGoBack from '@/shared/Dropdowns/DropdownListItem/DropdownListItemGoBack'
import DropdownListItemSettings from '@/shared/Dropdowns/DropdownListItem/DropdownListItemSettings'
import useLogout from '@/pages/User/hooks/useLogout.ts'
import Button from '@/shared/Buttons/Button'
import Avatar from '@/shared/Avatar'
import userUtils from '@/pages/User/user.utils'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  onOpenAccountSettingsSidePage: () => void
}

const ProfileIcon = (props: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(ref)
  const logoutAction = useLogout()
  const userState = useRecoilValue(userAtom)

  if (!userState || !userState.userInfo) {
    return <Skeleton height={'var(--input-height)'} width={'120px'} />
  }

  const handleSettingsClick = () => {
    requestAnimationFrame(() => setOpen(false))
    props.onOpenAccountSettingsSidePage()
  }

  return (
    <div
      className="inline-flex-gap gap8 center"
      style={{ cursor: 'pointer', position: 'relative' }}
      ref={ref}
      onClick={() => setOpen((prev) => !prev)}
    >
      <Button
        size="default"
        type="tetriary"
        icon={
          <Avatar
            size="small"
            userId={userState.userInfo.avatar ? userState.id : null}
            fileName={userState.userInfo.avatar ? userState.userInfo.avatar.fileName : null}
            online
            initials={userUtils.getUserAlias(userState.userInfo)}
          />
        }
        text={userUtils.getShortName(userState.userInfo)}
      />
      <DropdownFadeInPanel
        open={open}
        style={{ top: '45px', width: '220px' }}
        onClick={() => setOpen(false)}
        position="left"
      >
        <DropdownListItemSettings text="Настройки аккаунта" onClick={handleSettingsClick} />
        <DropdownListItemGoBack onClick={logoutAction} text="Выйти" />
      </DropdownFadeInPanel>
    </div>
  )
}

export default memo(ProfileIcon)
